import React from 'react'
import MissingTasksRequisitionsTable from './MissingTasksRequisitionsTable'
import { useFetch } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { RequisitionStatus, RequisitionType } from 'utils/enums'
import getEnumKeyByValue from 'utils/getEnumKeyByValue'

import styles from './MissingTasksController.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

const MissingTasksController = () => {
	const { i18n } = useGlobal()

	const { state, contents } = useFetch(
		`/tasks/missing_requisitions`,
		(json) => {
			return {
				requisitionId: json.requisitionId,
				requisitionType: getEnumKeyByValue(
					RequisitionType,
					json.requisitionType
				),
				requisitionState: getEnumKeyByValue(
					RequisitionStatus,
					json.requisitionState
				),
				processId: json.processId,
			}
		}
	)

	const isLoading = state === 'loading'

	return (
		<>
			{isLoading ? (
				<div className={styles['content']}>
					<h4>{i18n`Loading`}...</h4>
				</div>
			) : (
				<>
					{contents?.length ? (
						<div className={styles['content']}>
							<div className={styles['table-container']}>
								<h2
									className={styles['welcome-title']}
								>{i18n`Possible missing tasks`}</h2>
								<MissingTasksRequisitionsTable
									data={contents}
								/>
							</div>
						</div>
					) : (
						<div className={styles['content']}>
							<div className={styles['no-content-message']}>
								<h3
									className={styles['welcome-title']}
								>{i18n`Tasks up to date`}</h3>
								<Icon
									name='success'
									width='24px'
									height='24px'
								/>
							</div>
						</div>
					)}
				</>
			)}
		</>
	)
}

export default MissingTasksController
